var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotificationsRead(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 22,
    viewBox: "0 0 22 22",
    width: 22,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "#000",
      strokeWidth: 1.5,
      fill: "none",
      fillRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    transform: "translate(-4 -4)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m24.625 13.1666667v10.3125c0 .7593915-.6156085 1.375-1.375 1.375h-16.5c-.75939153 0-1.375-.6156085-1.375-1.375v-10.3125"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m18.8545329 18.3961995 2.3329671 2.3329672"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m11.1454671 18.3961995-2.3329671 2.3329672"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m24.6077844 13.0651286-7.5975344 6.6765381c-.520089.5571477-1.2480781.8734619-2.01025.8734619s-1.490161-.3163142-2.01025-.8734619l-7.59753443-6.6765381h-.01721557l.00860779-.0075643-.00860779-.0075643h.01721557l7.59753443-6.67653802c.520089-.55714769 1.2480781-.87346198 2.01025-.87346198s1.490161.31631429 2.01025.87346198l7.5975344 6.67653802h.0172156l-.0086078.0075643.0086078.0075643z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationsRead);
export default __webpack_public_path__ + "static/media/notifications-read.4821f1178a512791087a3a63cd012915.svg";
export { ForwardRef as ReactComponent };